import axios from 'axios';

export function getHostAgreementMe(token) {
    return axios.get(`${process.env.REACT_APP_API_URL}/legal/host-agreement/me`, {
        headers: { Authorization: token },
    });
}
